import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useEUAccountsStore } from '@/store_v3/EUAccountsStore';
import router from '@/router';
import { getCurrencyIcon } from "@/utils/translate";
import { useCopyText } from "@/utils/copyText";
import BaseEditableCard from '@/components-UI/BaseEditableCard.vue';
import BaseList from '@/components-UI/list/BaseList.vue';
import BaseListItem from '@/components-UI/list/BaseListItem.vue';
import BaseButton from '@/components-UI/BaseButton.vue';
import SvgCopy from "@/assets/icons/copy.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'ComponentSummary',
  setup(__props) {

const EUAccountStore = useEUAccountsStore();
const {
    form,
    EUAccountObj,
    isEdit,
    getServicesTotalSum,
    getNettingsTotalSum,
    getServicesToPaySelectedSum,
} = storeToRefs(EUAccountStore);
const { formatNumber } = EUAccountStore;

const isSingle = computed(() => router.currentRoute.params.id !== 'create');

const getCurrencySymbol = computed(() => getCurrencyIcon(form.value.currency));

/** Оплаченную часть считает бэк — на создании счёта её ещё нет. */
const paidSum = computed(() => Number(EUAccountObj.value?.paid_sum ?? 0));

const totalToPay = computed(() => {
    if (EUAccountObj.value && !isEdit.value && EUAccountObj.value.payable_services?.length) {
        return EUAccountObj.value.payable_services.reduce(
            (sum, item) => sum + Number(item.final_amount ?? 0),
            0,
        );
    }
    return Number(getServicesToPaySelectedSum.value ?? 0);
});

const copySummaryData = async (): Promise<void> => {
    const lines = [
        `Общая сумма услуг: ${formatNumber(getServicesTotalSum.value)} ${getCurrencySymbol.value}`,
        `Сумма взаимозачёта: ${formatNumber(getNettingsTotalSum.value)} ${getCurrencySymbol.value}`,
        `Сумма к оплате: ${formatNumber(totalToPay.value)} ${getCurrencySymbol.value}`,
    ];

    if (isSingle.value) {
        lines.push(`Оплачено: ${formatNumber(paidSum.value)} ${getCurrencySymbol.value}`);
    }

    const text = lines.join('\n');

    try {
        useCopyText(text, 'Успешно скопировано');
    } catch (err) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
        } catch (e) {
            console.error('Failed to copy text:', e);
        }
        document.body.removeChild(textArea);
    }
};

return { __sfc: true,EUAccountStore, form, EUAccountObj, isEdit, getServicesTotalSum, getNettingsTotalSum, getServicesToPaySelectedSum, formatNumber, isSingle, getCurrencySymbol, paidSum, totalToPay, copySummaryData, BaseEditableCard, BaseList, BaseListItem, BaseButton, SvgCopy }
}

})